<ui-card>
    <app-segment-header title="Departments"> </app-segment-header>
    <p>{{ 'reporting.payroll.journalEntry.inputDepartmentCodes' | translate }}</p>
    <p>{{ 'reporting.payroll.journalEntry.savingAutomatically' | translate }}</p>
    <form class="ui form" #form="ngForm">
        <div class="app-grid" *ngIf="departments">
            <div class="columns-6" *ngFor="let department of departments">
                <div class="app-grid">
                    <mat-form-field class="columns-8">
                        <mat-label>{{ department.name }}</mat-label>
                        <input
                            matInput
                            (focusout)="onDepartmentCodeChanged(department)"
                            type="string"
                            placeholder="e.g., 001"
                            [name]="'departmentCode' + department.id"
                            [(ngModel)]="department.departmentCode"
                        />
                    </mat-form-field>
                </div>
            </div>
        </div>
    </form>
</ui-card>
